"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryParamsBuilder = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Check whether is passed value an object or not
 *
 * @param {any} value
 * @returns {boolean}
 */
var isObject = function isObject(value) {
  return value === Object(value);
};
/**
 * Transform each property of passed object  as follow
 * paramKey = sort
 * paramObjValue = {
 *     field: 'name'
 *     sort: 'desc',
 * }
 *
 * became
 * {
 *     sort[field]: 'name',
 *     sort[sort]: 'desc',
 * }
 *
 * @param {string} paramKey
 * @param {object} paramObjValue
 * @returns {object}
 */


var transformParamObject = function transformParamObject(paramKey, paramObjValue) {
  return Object.keys(paramObjValue).reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, "".concat(paramKey, "[").concat(key, "]"), paramObjValue[key]));
  }, {});
};
/**
 * Transform passed params object into a query param string of the following format:
 * param1=value&param2[field1]=value&param2[field2]=value
 *
 * @param {object} requestParams
 * @param {object} options
 * @returns {string}
 */


var queryParamsBuilder = function queryParamsBuilder() {
  var requestParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    skipNull: true
  };
  var flatParams = Object.keys(requestParams).reduce(function (acc, key) {
    var param = requestParams[key];

    if (options.skipNull && (param === null || param === undefined || param === '')) {
      return acc;
    }

    return _objectSpread(_objectSpread({}, acc), isObject(param) ? transformParamObject(key, param) : _defineProperty({}, key, param));
  }, {});
  return _queryString["default"].stringify(flatParams, options);
};

exports.queryParamsBuilder = queryParamsBuilder;